import * as React from 'react';
import { QuotesIcon } from '../igniter/Icons';

interface IProps {
  testimonial: ITestimonial;
}

export interface ITestimonial {
  name: string;
  comment: string;
  title: string;
  organization?: string;
  image_path: string;
}

export class Testimonial extends React.Component<IProps, object> {
  render() {
    const { testimonial } = this.props;
    const {
      name: fullName,
      comment,
      title,
      organization,
      image_path: imagePath,
    } = testimonial;

    return (
      <section className="testimonial grid-x">
        <div className="cell shrink">
          <img
            src={imagePath}
            alt={fullName}
          />
        </div>
        <div className="cell auto">
          <QuotesIcon />

          <div className="details">
            <div className="comment">{comment}</div>
            <div className="name">{fullName}</div>
            <div className="title">{organization ? `${title}, ` : title}</div>
            <div className="organization">{organization}</div>
          </div>
        </div>
      </section>
    );
  }
}
